/* eslint-disable no-unused-vars */
import { Form, Checkbox } from 'antd';
import OptionsList from './Categories/OptionsList';

export default function RecursiveComponent({ treeData, parentId = 0, level = 0 }) {
    const items = treeData.filter((item) => item.parent === parentId);
    if (!items.length) return null;
    // console.log(parentId, items);
    return (
        <>
            {items.map((item) => (
                <OptionsList key={item.id} item={item} level={level}>
                    <RecursiveComponent treeData={treeData} parentId={item.id} level={level + 1} />
                </OptionsList>
            ))}
        </>
    );
}
